import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import { styles } from '../styles/js/header'
import { withStyles } from '@material-ui/core'

const HeaderComponent = ({ classes, title, description }) => {
  return (
    <Grid container justifyContent='center' className={classes.root}>
      <Grid item xs={12} style={{ zIndex: 999 }}>
        <Typography variant='h1' className={classes.title}>
          {title}
        </Typography>
      </Grid>

      <Grid item xs={12} style={{ zIndex: 999 }}>
        <Typography variant='h5' className={classes.description}>
          {description}
        </Typography>
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(HeaderComponent)
